
<template lang="pug">
section(v-if="visible")
  main.body(@touchmove="(e) => e.preventDefault()")
    .content
      h3.title
        | {{ title }}
      slot
        p {{ content }}
      footer.btn-group
        button.cancel(v-if="showCancel", @click="onCancel")
          | {{ cancelText }}
        button.confirm(@click="onConfirm")
          | {{ confirmText }}
  .mask(@touchmove="(e) => e.preventDefault()")
</template>

<script>
const defaultOption = {
  title: '',
  content: '',
  showCancel: true,
  confirmText: '确认',
  cancelText: '取消',
};

export default {
  name: 'Dialog',
  props: {
    pageId: {
      type: String,
      default: 'new_mybonus',
    },
  },
  data() {
    return {
      visible: false,
      resolve: null,
      reject: null,
      ...defaultOption,
    };
  },
  methods: {
    open(option) {
      this.$emit('open');
      return new Promise((resolve, reject) => {
        this.render(option);
        this.visible = true;
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    render(option = {}) {
      ({
        title: this.title,
        content: this.content,
        showCancel: this.showCancel,
        confirmText: this.confirmText,
        cancelText: this.cancelText,
      } = { ...defaultOption, ...option });
    },
    onCancel() {
      this.visible = false;
      this.reject();
      this.render();
    },
    onConfirm() {
      this.visible = false;
      this.resolve();
      this.render();
    },
  },
};
</script>

<style scoped>
.body {
  position: fixed;
  z-index: 10;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content {
  position: relative;
  width: 3rem;
  background: white;
  border-radius: 0.06rem;
  padding: 0.2rem;
  margin-top: -0.2rem;
}

.title {
  font-size: 0.18rem;
  font-weight: 500;
  color: #333;
  text-align: center;
}

.btn-group {
  font-size: 0.16rem;
  display: flex;
  margin-top: 0.2rem;
  justify-content: space-between;
  align-items: center;
}

.btn-group > button {
  border-radius: 0.03rem;
  font-size: 0.16rem;
  box-sizing: border-box;
  background: #0b82f1;
  color: white;
  flex: 1;
  line-height: 1;
  padding: 0.12rem 0;
}

.btn-group > button:nth-child(n + 2) {
  margin-left: 0.1rem;
}

.btn-group > .cancel {
  background: white;
  color: #0b82f1;
  border: 1px solid rgba(11, 130, 241, 1);
}

.mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9;
}
</style>
